var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaymentAction',{attrs:{"id":_vm.$route.params.id},on:{"close":function($event){return _vm.$router.push({ path: '/payments' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }